import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAzuredevopsComponent } from './simple-icons-azuredevops.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAzuredevopsComponent ],
    exports:      [ SimpleIconsAzuredevopsComponent ],
    bootstrap:    []
})
export class SimpleIconsAzuredevopsModule {}
